<template>
  <div>
    <Header
      :history="history"
      @goBack="goBack"
      @close="close"
    />

    <transition name="fade">
      <div v-if="isSuccess" :style="`height: ${contentHeight}px`">
        <Map
          v-if="hasRole('report', 'ROLE_GET_REPORT_TAXIJOBS') && hasRole('report', 'ROLE_GET_REPORT_CHART')"
          :imageSrc="drawerData.routeUrl"
        />

        <Tabs
          v-if="hasRole('report', 'ROLE_GET_REPORT_TAXIJOBS')"
          :data="drawerData"
          @change="change"
        />

        <EmptyState
          v-else
          image="employee"
          :imageSize="120"
          class="px-4"
        >
          <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
        </EmptyState>
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'libs/moment'
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole } from 'utils/functions'
import { calcContentHeight, isValidArray, isValidObject, catchError } from 'corp-front-vue-commons/src/utils/functions'
import Header from './Header'
import Map from './Map'
import Tabs from './Tabs'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Ride',
  props: {
    data: {
      type: Object,
      default: () => {}
    },

    history: {
      type: Array,
      default: () => []
    },

    filters: {
      type: Object
    }
  },
  components: {
    Header,
    Map,
    Tabs,
    EmptyState
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidArray (val) {
      return isValidArray(val)
    },

    isOValidbject (val) {
      return isValidObject(val)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close () {
      this.$emit('close')
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (this.currentStatus === STATUS_IS_LOADING || !this.hasRole('report', 'ROLE_GET_REPORT_TAXIJOBS')) {
        this.currentStatus = STATUS_SUCCESS
        return
      }

      this.currentStatus = STATUS_IS_LOADING

      try {
        let startDate = null
        let endDate = null

        if (this.isOValidbject(this.filters)) {
          startDate = this.filters.startDate || null
          endDate = this.filters.endDate || null
        }

        if (this.isOValidbject(this.data) && this.data.startDate) {
          const daysInMonth = moment(this.data.startDate).daysInMonth()
          startDate = moment(this.data.startDate).format('YYYY-MM-') + '01'
          endDate = moment(this.data.startDate).format('YYYY-MM-') + daysInMonth
        }

        const companyId = this.selectedCompany ? this.selectedCompany.id : null
        const { data: res } = await this.$apiService.reports.getRides(
          { page: 1 },
          { limit: 1 },
          { taxiJobId: this.data.id },
          { startDate },
          { endDate },
          { companyId }
        )

        this.drawerData = this.isValidArray(res.data) && this.isOValidbject({ ...res.data[0] })
          ? res.data[0]
          : {}

        this.$emit('updateHistory', {
          drawerType: 'ride',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        catchError(error)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}
</style>
